import { fa_number } from "../../utils/Persian";
import { safeParseHtml } from "../../utils/safeParseHtml";

function Faq({data}:any) {
    if (data) {
        var indexToSplit = data.length / 2;
        var faq1 = data.slice(0, indexToSplit);
        var faq2 = data.slice(indexToSplit);
    }
    return ( 
        <div className="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-4 mx-auto" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger text-uppercase">سوالات متداول</h5>
                    <h1 className="mb-0">پاسخ به سوالات شما</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                        <div className="accordion accordion-flush" id="faqAccordion">
                            {faq1 && faq1.map((row:any,index:number) => 
                            <div className="accordion-item" key={index}>
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed fw-bold rounded" type="button" data-bs-toggle="collapse" data-bs-target={`#faq1_${index}`} aria-expanded="false" aria-controls={`faq1_${index}`}>
                                        {`${fa_number(index+1)}. ${row.question}`}
                                    </button>
                                </h2>
                                <div id={`faq1_${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`} data-bs-parent="#faqAccordion">
                                    <div className="accordion-body">
                                        {safeParseHtml(row.answer)}
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>

                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                        <div className="accordion accordion-flush" id="faqAccordion2">
                            {faq2 && faq2.map((row:any,index:number) => 
                            <div className="accordion-item" key={index}>
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed fw-bold rounded" type="button" data-bs-toggle="collapse" data-bs-target={`#faq2_${index}`} aria-expanded="false" aria-controls={`faq2_${index}`}>
                                        {`${fa_number(index+indexToSplit+1)}. ${row.question}`}  
                                    </button>
                                </h2>
                                <div id={`faq2_${index}`} className="accordion-collapse collapse" data-bs-parent="#faqAccordion2">
                                    <div className="accordion-body">
                                        {safeParseHtml(row.answer)}
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>

            </div>
        </div>
     );
}

export default Faq;
